// Settings and the writer's profile, at the right of the Library's masthead and a project's top bar: a gear for this
// browser's settings, and the writer's initial (else a figure) for the profile, where they sign out.
import { authorName } from '../store/useProject.ts';
import { Icon } from '../views/Icons.tsx';
import { followLink, useRoute } from './route.ts';

/** The first letter of the account's name, as the profile button shows it. */
export function initialOf(name: string | null): string | null {
  const first = name?.trim().match(/\p{L}|\p{N}/u)?.[0];
  return first ? first.toLocaleUpperCase() : null;
}

/** The profile's circle: the initial, else a figure. */
export function Avatar({ name, size = 28 }: { name: string | null; size?: number }) {
  const initial = initialOf(name);
  return (
    <span className={`avatar avatar-${size}`} aria-hidden="true">
      {initial ?? <Icon name="person" size={Math.round(size * 0.55)} />}
    </span>
  );
}

export function AccountLinks() {
  const route = useRoute();
  // The name the Library and profile last read from the relay (they keep it here); none yet shows a figure.
  const name = authorName();
  return (
    <nav className="account-links" aria-label="Settings and profile">
      <a
        className="icon-link"
        href="/settings"
        title="Settings"
        aria-label="Settings"
        aria-current={route.name === 'settings' ? 'page' : undefined}
        onClick={(e) => followLink(e, '/settings')}
        data-settings-link
      >
        <Icon name="gear" size={18} />
      </a>
      <a
        className="avatar-link"
        href="/profile"
        title={name ? `${name}: your profile` : 'Your profile'}
        aria-label={name ? `Your profile (${name})` : 'Your profile'}
        aria-current={route.name === 'profile' ? 'page' : undefined}
        onClick={(e) => followLink(e, '/profile')}
        data-profile-link
      >
        <Avatar name={name} />
      </a>
    </nav>
  );
}
